import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/kit';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-4 py-12 bg-lila-50 border-t border-lila-100" data-id="element-74" data-mp="1hdbftsfyjr8d">
      <div className="max-w-3xl mx-auto" data-id="element-75" data-mp="1hbgvaf8lm14t">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-wine text-center mb-7" data-id="element-76" data-mp="1cf9ko959c1gj">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-3" data-id="element-77" data-mp="2a1h1cheu5k99">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="border border-lila-200 rounded-xl bg-white overflow-hidden" data-id="element-78" data-mp="2042jqeh6epfd" data-mpi={i}>
                <button className="w-full px-5 sm:px-6 py-4 text-left flex justify-between items-center gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500 rounded-xl" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} data-id="element-79" data-mp="1v583nkalfeyy">
                  <span className="font-extrabold text-wine uppercase text-sm sm:text-[15px] leading-snug" data-id="element-80" data-mp="1klnglzmjjyhc">
                    {faq.q}
                  </span>
                  {isOpen ? <Minus className="w-5 h-5 text-rose-600 shrink-0" data-id="element-81" data-mp="1arn61i8hq118" /> : <Plus className="w-5 h-5 text-ink-soft shrink-0" data-id="element-82" data-mp="1fmssqj9pvjqd" />}
                </button>
                {isOpen && <div id={`faq-${i}`} className="px-5 sm:px-6 pb-4 text-ink-muted leading-relaxed" data-id="element-83" data-mp="16oh3akkl6rzi">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}